export default __webpack_public_path__ + "static/media/skippedmeal_5@3x.e7670689.jpg";